import restaurantSortOptions, {
  sortOptionLabels,
  type SortOption,
} from '@discover-data/stores/restaurant/model/sort/options';

export type SortOptionWithLabels = {
  label: string;
  value: SortOption;
};

export const sortValues = [
  ...Object.values(restaurantSortOptions).filter(
    (option) => option !== restaurantSortOptions.NEAREST
  ),
] as const satisfies readonly SortOption[];

export const sortOptions = sortValues.map((value) => ({
  label: sortOptionLabels[value],
  value,
})) satisfies readonly SortOptionWithLabels[];
